var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navBar"},[_c('ul',{staticClass:"nav fr ac jsb"},[(_vm.showBack)?_c('li',{staticClass:"ico backIco",on:{"click":function($event){_vm.$router.back(-1)}}}):_c('li',{staticClass:"ico"}),_vm._v(" "),_c('li',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('li',{staticClass:"ico shareIco"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-566c276d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/navBar.vue
// module id = null
// module chunks = 